import { Outlet, useLocation } from "react-router";

type GlowLayout = "center" | "top" | "right";

const getGlowLayout = (pathname: string): GlowLayout => {
  if (pathname === "/playbook") return "center";
  if (
    pathname.startsWith("/playbook/guides") ||
    pathname.startsWith("/playbook/faqs")
  )
    return "right";
  return "top";
};

export const PlaybookLayout = () => {
  const location = useLocation();

  const layout = getGlowLayout(location.pathname);
  const transformX = layout === "right" ? "50%" : "0";
  const transformY = layout === "center" ? "0" : "-50%";
  return (
    <div className="relative flex flex-col p-4xl">
      {/* Use SVG instead of CSS gradient to get grainy texture from feTurbulence */}
      <svg
        key={location.pathname}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1280 442"
        width="1280"
        height="442"
        preserveAspectRatio="none"
        className="absolute top-0 left-0 z-[-1] w-full"
        style={{ transform: `translate(${transformX}, ${transformY})` }}
      >
        <defs>
          <radialGradient id="playbook-gradient" cx="50%" cy="50%" r="50%">
            <stop offset="40%" stopColor="#FFF04D" stopOpacity="1" />
            <stop offset="100%" stopColor="#FFF04D" stopOpacity="0" />
          </radialGradient>
          <filter id="playbook-filter">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.55"
              numOctaves="2"
              seed="2"
              stitchTiles="stitch"
              result="noise"
            />
            <feColorMatrix
              type="saturate"
              values="0"
              in="noise"
              result="grey"
            />
            <feComponentTransfer in="grey" result="inverted">
              <feFuncR type="linear" slope="-1" intercept="1" />
              <feFuncG type="linear" slope="-1" intercept="1" />
              <feFuncB type="linear" slope="-1" intercept="1" />
            </feComponentTransfer>
            <feComponentTransfer in="inverted" result="faded">
              <feFuncA type="linear" slope="0.3" />
            </feComponentTransfer>
            <feBlend
              in="SourceGraphic"
              in2="faded"
              mode="soft-light"
              result="blended"
            />
            <feComposite in="blended" in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
        <rect
          width="100%"
          height="100%"
          fill="url(#playbook-gradient)"
          filter="url(#playbook-filter)"
        />
      </svg>
      <Outlet />
    </div>
  );
};
